import type { QuoteListFilters } from '../types';

/**
 * Query key factory for the Quotes feature.
 *
 * Always derive keys from this factory rather than hand-writing arrays so
 * mutation invalidation stays consistent across the list, detail and Kanban
 * surfaces.
 *
 * Layout:
 *   ['quotes']
 *   ['quotes', 'list']
 *   ['quotes', 'list', { ...filters }]    ← table view
 *   ['quotes', 'kanban']
 *   ['quotes', 'kanban', { ...filters }]  ← Kanban view (typically wider page)
 *   ['quotes', 'detail']
 *   ['quotes', 'detail', id]
 *   ['quotes', 'statuses']                ← reserved for future workflow lookups
 */
export const quoteKeys = {
  all: ['quotes'] as const,
  lists: () => [...quoteKeys.all, 'list'] as const,
  list: (filters: QuoteListFilters) => [...quoteKeys.lists(), filters] as const,
  kanbans: () => [...quoteKeys.all, 'kanban'] as const,
  kanban: (filters: QuoteListFilters) =>
    [...quoteKeys.kanbans(), filters] as const,
  details: () => [...quoteKeys.all, 'detail'] as const,
  detail: (id: string) => [...quoteKeys.details(), id] as const,
  statuses: () => [...quoteKeys.all, 'statuses'] as const,
  statusHistory: (id: string) =>
    [...quoteKeys.all, 'status-history', id] as const,
};
